import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalDateField from 'components/new_ui/Form/HorizontalDateField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Members/Profile/Actions';
import Modal from 'components/new_ui/Modal/Modal';

import { useNavigate } from 'react-router-dom';

import useTimeZones from 'components/Common/TimeZones/Hooks/useTimeZones';
import usePhoneCountries from 'components/Common/Countries/Hooks/usePhoneCountries';
import useCountries from 'components/Common/Countries/Hooks/useCountries';
import StateField from 'components/Common/Affiliates/Form/StateField';

import genders from 'data/genders';

export default function Basic() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const { timeZones } = useTimeZones();
  const { countries } = useCountries();
  const phoneCountries = usePhoneCountries();

  const navigate = useNavigate();

  const member = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    email: Yup.string().required('Work Email is required'),
    time_zone: Yup.string().typeError('Time Zone is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      member.id,
      {
        ...values,
        state_name: values.stateName,
        birthday: values.birthday
          ? new Date(values.birthday.getTime()
          - values.birthday.getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0] : null,

      },
      true,
      () => {
        setSubmitting(false);
        actionsUsers.load(dispatchUsers);
        navigate(-1);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal size="lg" show>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          email: stateUsers.user.attributes.email,
          time_zone: member.time_zone,
          phone: member.phone_without_country,
          phone_country_with_prefix: member.phone_country && member.phone_code
            ? `${member.phone_country}_${member.phone_code}` : null,
          phone_country: member.phone_country,
          phone_code: member.phone_code,
          birthday: new Date(member.birthday),
          gender: member.gender,
          country: member.country,
          stateName: member.state_name,
          city_name: member.city_name,
          address1: member.address1,
          address2: member.address2,
          zip_code: member.zip_code,

        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting, values, setFieldValue }) => {
          useEffect(() => {
            if (values.phone_country_with_prefix) {
              const [country, prefix] = values.phone_country_with_prefix.split('_');
              setFieldValue('phone_country', country);
              setFieldValue('phone_code', prefix);
            } else {
              setFieldValue('phone_country', '');
              setFieldValue('phone_code', '');
            }
          }, [values.phone_country_with_prefix]);
          return (
            <FormikForm className="needs-validation" noValidate="">
              <Row>

                <Col md={6}>
                  <HorizontalSelectField
                    name="gender"
                    label="Gender"
                    placeholder="Select Gender"
                    options={genders}
                  />
                </Col>

                <Col md={6}>
                  <HorizontalDateField
                    name="birthday"
                    label="Birthday"
                  />
                </Col>

              </Row>

              {!stateUsers.user.attributes.is_mobile_login && (
                <Row>
                  <Col>
                    <HorizontalTextField
                      name="email"
                      label="Work Email"
                      required
                    />
                  </Col>
                </Row>
              )}

              <Row>
                <Col md={6}>
                  <HorizontalSelectField
                    name="phone_country_with_prefix"
                    label="Phone Country"
                    placeholder={phoneCountries === null ? 'Loading...' : 'Select Phone Country'}
                    options={phoneCountries === null ? [] : phoneCountries.map((item) => ({
                      value: `${item.country}_+${item.prefix}`,
                      label: item.title,
                    }))}
                  />
                </Col>

                <Col md={6}>
                  <HorizontalTextField name="phone" label="Phone" />

                  <HorizontalTextField name="phone_country" type="hidden" />
                  <HorizontalTextField name="phone_code" type="hidden" />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <HorizontalSelectField
                    name="country"
                    label="Country"
                    placeholder={countries === null ? 'Loading...' : 'Select Country'}
                    options={countries === null ? [] : countries}
                  />
                </Col>

                <Col md={6}>
                  <StateField />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <HorizontalTextField name="city_name" label="City" />
                </Col>

                <Col md={6}>
                  <HorizontalTextField name="zip_code" label="Zip Code" />
                </Col>
              </Row>

              <Row>
                <Col>
                  <HorizontalTextField as="textarea" name="address1" label="Address 1" />
                </Col>
              </Row>

              <Row>
                <Col>
                  <HorizontalTextField as="textarea" name="address2" label="Address 2" />
                </Col>
              </Row>

              <Row>
                <Col>
                  <HorizontalSelectField
                    name="time_zone"
                    label="Time Zone"
                    placeholder={timeZones === null ? 'Loading...' : 'Select Time Zone'}
                    options={timeZones === null ? [] : timeZones}
                    required
                  />
                </Col>

              </Row>

              <Footer loading={isSubmitting} onCancel={() => navigate(-1)} />
            </FormikForm>
          );
        }}
      </Formik>
    </Modal>
  );
}
